import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Row } from 'antd';

import ProfileForm from './ProfileForm';
import LoadingSpinner from '../../../lib/components/loadingSpinner';
import env from '../../../lib/env';
import { TeacherLayout } from '../../layouts/TeacherLayout';
import { FormattedMessage } from 'react-intl';

function ProfilePage (props) {
  const { isLoading, user = {}, teacher = {} } = props;

  return (
    <TeacherLayout user={user} teacher={teacher}>
      <LoadingSpinner spinning={isLoading} fullscreen>
        <ProfileForm teacher={teacher} isLoading={isLoading} />
        <Row style={{ margin: '15px auto' }} gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={20} xl={8}>
            <Link to={{ pathname: `https://app.termly.io/notify/${env.REACT_APP_TERMLY_LUSPI_UUID}` }} target='_blank' style={{ textDecoration: 'underline' }}> <FormattedMessage id="profile.main.cookie-link"/></Link>
          </Col>
          <Col xs={24} sm={20} xl={8}>
            <Link to={{ pathname: `https://app.termly.io/notify/${env.REACT_APP_TERMLY_LUSPI_UUID}` }} target='_blank' style={{ textDecoration: 'underline' }}> <FormattedMessage id="profile.main.personal-data-link"/></Link>
          </Col>
        </Row>
      </LoadingSpinner>
    </TeacherLayout>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    teacher: state.teachers.profile,
    isLoading: state.teachers.isLoading
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
